import { Component } from "vue"
import { RouteLocationRaw } from "vue-router"
import { ValidationRule } from "@/types/ValidationRule"
import { ActionConditions } from "./flowRaw"
import { TFunction } from "../utils"
import { OutputType } from "@/flows/Deserializer"

export const isInputElement = (
  element: IStepElement,
): element is IStepInputElement =>
  (<IStepInputElement>element).key !== undefined

export interface IStepDisplayElement {
  is: Component
  props: Record<string, unknown>
  slots: any
  isShown: boolean
  showBelowActions: boolean
}

export interface IStepInputElement extends IStepDisplayElement {
  key: string
  initialValue: any
  optional?: boolean
  rules?: ValidationRule[]
}

export type IStepElement = IStepDisplayElement | IStepInputElement

export interface IStepAction {
  buttonLabel: string
  buttonType?: string
  nextIf?: ActionConditions
  showIf?: OutputType
  showIfNot?: OutputType
  nextId?: string
  disabled?: boolean
  saveTo?: TFunction
  to?: string | RouteLocationRaw
  getNextStep(): Promise<string | null>
  deserializeCondition: (
    condition: boolean | string,
  ) => Promise<boolean | string>
}

export interface IStep {
  id: string
  title?: string
  isFirst?: boolean
  description?: string
  descriptionHtml?: string[]
  hideHelpText?: boolean
  elements?: IStepElement[]
  actions?: IStepAction[]
}

export interface IFlow {
  steps: IStep[]
  helpTitle?: string
  helpContent?: Component
}
